
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("jwd3r", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $1db817a573e1b38d$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Portuguese (Brazil)
var $1db817a573e1b38d$export$2e2bcd8739ae039 = {
    'fabric.elements.mentions.team.member.50plus': "Equipe \u2022 Mais de 50 membros",
    'fabric.elements.mentions.team.member.50plus.including.you': "Equipe \u2022 Mais de 50 membros, incluindo voc\xea",
    'fabric.elements.mentions.team.member.count': "{0, plural, one {Equipe \u2022 1 membro} other {Equipe \u2022 {0} membros}}",
    'fabric.elements.mentions.team.member.count.including.you': "{0, plural, one {Equipe \u2022 1 membro, incluindo voc\xea} other {Equipe \u2022 {0} membros, incluindo voc\xea}}",
    'fabric.elements.mentions.xproduct.mention.description': "\xc9 necess\xe1rio ter acesso ao Confluence",
    'fabric.mention.error.defaultAction': 'Tente novamente em alguns segundos',
    'fabric.mention.error.defaultHeadline': 'Algo deu errado',
    'fabric.mention.error.differentText': 'Tente inserir outro texto',
    'fabric.mention.error.loginAgain': 'Tente sair e fazer login novamente',
    'fabric.mention.noAccess.label': 'Sem acesso',
    'fabric.mention.noAccess.warning': "{name} n\xe3o ser\xe1 notificado(a) porque n\xe3o tem acesso",
    'fabric.mention.unknow.user.error': "Usu\xe1rio desconhecido {userId}"
};

});


//# sourceMappingURL=pt_BR.ea61b74c.js.map
